<div class="d-print-none border-top border-colour-grayscale-200">
  @if (showDisclaimer()) {
    <section
      class="disclaimer container d-print-none py-4"
      >
      <div class="row">
        <div class="col">
          <p class="box-simple">
            This website is designed to give professional financial advisers information and tools that they can use to
            help
            control and develop their business and should not be relied upon by private investors or any other persons.
            <br><br>
            It remains the responsibility of the regulated firm or financial adviser using Ignite to ensure that the
            information they provide is accurate (including but not limited to the application of fees, any cost
            calculations and the documentation provided) and that the advice they provide is in line with MCOBs rules and
            guidance.
            <br><br>
            If you are unsure you can contact our product support team at
            <a href="mailto: lgmstechsupport@landg.com">lgmstechsupport&#64;landg.com</a>
          </p>
          <p class="box-simple mt-2">
            Product disclaimer: Lenders may launch a new Product or withdraw a Product at any time without prior notice.
            Please check directly with the lender regarding product availability and how criteria may affect this.
          </p>
          <p class="box-simple pt-0 mt-2">
            The Sub-Processor engaged by L&G is as follows: IDOL/Investments Discounts On Line Limited
            (company number 04231834) with registered office at <u>One Coleman Street, London, EC2R 5AA</u>.
          </p>
        </div>
      </div>
    </section>
  }
  <footer class="footer-wrapper container-fluid pt-2 border-top border-colour-grayscale-200">
    <div class="container mt-5 mb-6">
      <div class="row">
        <div class="col-7">
          <div class="d-flex">
            <a
              href="https://www.linkedin.com/company/legal-&amp;-general"
              target="_blank"
              title="Visit our LinkedIn page"
              aria-label="Visit our LinkedIn page"
              >
              <div
                ngskiphydration="true"
                class="footer__social-icon lg-icon"
                aria-hidden="true"
                >
                <lib-svg-icon icon="linkedin" class="svg-24-no-pad d-inline-block" [fill]="true"/>
              </div>
            </a>
            <a
              href="https://twitter.com/landg_uk"
              target="_blank"
              title="View our X feed"
              aria-label="View our X feed"
              >
              <div
                ngskiphydration="true"
                class="footer__social-icon lg-icon"
                aria-hidden="true"
                >
                <lib-svg-icon icon="x" class="svg-24-no-pad d-inline-block" [fill]="true"/>
              </div>
            </a>
          </div>
          <div class="mt-5">
            <a
              href="https://www.legalandgeneral.com/accessibility/"
              target="_blank"
              data-analytics="Accessibility"
              >
              Accessibility
            </a>
            <a
              href="https://www.legalandgeneral.com/adviser/mortgage-club/legal-information/"
              target="_blank"
              data-analytics="Legal and regulatory information"
              >
              Legal and regulatory information
            </a>
            <a
              href="https://www.legalandgeneral.com/adviser/privacy-policy/"
              target="_blank"
              data-analytics="Professional Business Privacy policy"
              >
              Professional business privacy policy
            </a>
          </div>
          <div class="mt-3">
            <a
              href="https://www.legalandgeneral.com/adviser/cookie-policy/"
              target="_blank"
              data-analytics="Cookie policy"
              >
              Cookie policy
            </a>
            <a
              href="https://www.legalandgeneral.com/adviser/security-information/"
              target="_blank"
              data-analytics="Security"
              >
              Security information
            </a>
            <a
              href="https://www.legalandgeneral.com/adviser/all-our-websites/"
              target="_blank"
              data-analytics="All our websites"
              >
              All our websites
            </a>
            <a
              href="https://careers.legalandgeneral.com/"
              target="_blank"
              rel="noopener noreferrer"
              data-analytics="Legal &amp; General Group Careers"
              >
              Careers
            </a>
          </div>
          <div class="mt-5">
            <p>&copy; Legal & General Group plc {{ year }}</p>
          </div>
        </div>
        <div class="col-5 d-flex justify-content-end align-items-end mb-3">
          <a
            class="footer-logo-link"
            href="https://www.legalandgeneral.com/"
            target="_blank"
            >
            <img
              class="mb-2 footer-logo logo-light-only"
              alt="Legal and General"
              [src]="landgLogoUrl"
              />
            <img
              class="mb-2 footer-logo logo-dark-only"
              alt="Legal and General"
              loading="lazy"
              [src]="landgLogoDarkUrl"
              />
          </a>
        </div>
      </div>
    </div>
  </footer>
</div>
